import { render, staticRenderFns } from "./PersonIdentification.vue?vue&type=template&id=4516ea98&scoped=true&"
import script from "./PersonIdentification.vue?vue&type=script&lang=js&"
export * from "./PersonIdentification.vue?vue&type=script&lang=js&"
import style0 from "./PersonIdentification.vue?vue&type=style&index=0&id=4516ea98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4516ea98",
  null
  
)

export default component.exports